

import { SmetioCustomerWebsiteSection } from "../../smetioCustomerWebsiteSection.js/v1.0.0/SmetioCustomerWebsiteSection.js";

export class SmetioCustomerWebsiteTeamMembers extends SmetioCustomerWebsiteSection {

      constructor(data = {}) {


            super(data);

            this.sectionId = "smetio-template-team";
            this.teamMembersArray = [];
            this.teamMembers = {};
            this.table = "teamMembers";
            this.appUserInterface = "business";
            this.nextSectionClass = null;

            this.mainClass = "smetio-customer-website-team-members-" + this.id;
            this.mainAttributes = {
                  id: this.sectionId,
                  class: ["smetio-customer-website-team-members", this.mainClass],
            };

            this.teamMembersItemsClass = "smetio-customer-website-teamMembers-items-" + this.id;
            this.teamMembersItemsAttributes = {
                  class: ["smetio-customer-website-teamMembers-items", this.teamMembersItemsClass],
            };


      };

      getSettingsForOneTeamMember() {
            
            return {
                  orientation: "horizontal",
                  boxWidth:"100%",
                  boxMinWidth: "250px",
                  boxMaxWidth:  "1000px",
                  // boxMaxWidth: "400px",
                  boxMaxHeight: "2000px",
                  boxMinHeight: "450px",
                  boxMargin: "10px",
                  boxPadding: "10px",
                  photoWidth: "50%",
                  photoVPosition: "center",
                  descriptionVPosition: "top",
                  horizontalIsResponsive: true
            };
      };

      async displayTeamMembers() {

            const extractCdnPathFromOneValueOfSmetioFileInput = (await import(/* webpackPrefetch: true */ "@schaniag/private")).extractCdnPathFromOneValueOfSmetioFileInput;
            const SmetioPhotoAndDescription = (await import(/* webpackPrefetch: true */ "../../smetioPhotoAndDescription/v1.0.0/smetioPhotoAndDescription.js")).SmetioPhotoAndDescription;

            const yearsText = this.setTxt({
                  attributes: {},
                  txt: "txt816",
                  type: "html"
            });

            const bookText = this.setTxt({
                  attributes: {},
                  txt: "txt1356",
                  type: "html"
            });


            let boxWidth = "250px";

            switch (this.totalNumberOfData) {

            case 1: boxWidth = "60%";
                  break;

            case 2: boxWidth = "45%";
                  break;

            case 3: boxWidth = "30%";
                  break;

            case 4: boxWidth = "300px";
                  break;

            default: boxWidth = "250px";

                  break;
            };

            console.log("this.totalNumberOfData is ", this.totalNumberOfData, " boxWidth is ", boxWidth);

            let settings = {
                  orientation: "vertical",
                  boxWidth,
                  boxMinWidth: "250px",
                  boxMaxWidth: this.totalNumberOfData > 4 ? "250px" : "400px",
                  // boxMaxWidth: "400px",
                  // boxMaxHeight: this.totalNumberOfData > 4 ? "600px" : "700px",
                  boxMinHeight: "250px",
                  boxMaxHeight:"650px",      
                  boxMargin: "10px",
                  boxPadding: "10px",
                  photoWidth: "100%",
                  photoVPosition: "center",
                  descriptionVPosition: "top",
            };

            // if(this.totalNumberOfData == 1) settings = this.getSettingsForOneTeamMember();


            for (let i = 0; i < this.teamMembersArray.length; i++) {

                  const teamMemberDetails = this.teamMembersArray[i];
                
                  const { firstName, lastName, token, websiteMultimedia, jobTitle, skillLevel, yearsOfExperience, bio, showOnWebsite } = teamMemberDetails;
                  
                  if (showOnWebsite !== true) continue;

                  const { homePhoto_desktop, aboutPhoto_desktop } = websiteMultimedia || {};

                  const photo = extractCdnPathFromOneValueOfSmetioFileInput(aboutPhoto_desktop);

                  let title = skillLevel === "notApplicable" ? jobTitle : `${skillLevel} ${jobTitle}`;
                  title = title.toUpperCase();

                  const experience = yearsOfExperience ? `${yearsOfExperience}+ ${yearsText}` : "";
                  // const bioText = this.totalNumberOfData == 1 ? `<div class="smetio-customer-website-description-bio" >${bio || ""} </div>` : "";
                  const bioText = "";

                  const description = `
                        <div class="smetio-customer-website-team-member-description"  >

                              <div class="smetio-customer-website-team-member-description-text">
                                    <h4>${firstName} ${lastName}</h4>
                                    <p class="smetio-customer-website-description-title">${title}</p>
                                    <p class="smetio-customer-website-description-experience">${experience.toLowerCase()} </p>
                                    ${bioText}
                              </div>

                              <!--
                              <button class="smetio-customer-website-description-book-with-me" >
                                    <a href="#">${bookText}</a>
                              </button>  
                              -->

                        </div>
                  `;

                  const smetioPhotoAndDescription = new SmetioPhotoAndDescription({
                        photo,
                        description,
                        // isSelected: option.attributes.selected,
                        ...settings,
                        // onClicked: (data = {}) => {
                        //   console.log("You clicked token ", token);
                        //   this.zoomMapIn({token});
                        //   this.showBusinessLocationDetails({ token })
                        // },
                        // onMouseEnter: (data = {}) => {
                        //   console.log("You clicked token ", token);
                        //   this.zoomMapIn({token});
                        // },
                        // onMouseLeave:(data = {}) => {
                        //   console.log("You clicked token ", token);
                        //   this.zoomMapOut();
                        // },
                  });

                  const teamMember = smetioPhotoAndDescription.render();

                  if (i < 1) $(`.${this.teamMembersItemsClass}`).html("");

                  $(`.${this.teamMembersItemsClass}`).append(teamMember);

                  this.teamMembers[token] = i;

                  // if(i > 0) break;
                  // break;

            };

      };

      async getTeamMembers() {

            const funcData = this.getFuncData();

            // this.totalNumberOfData = await this.getTotalNumberOfAvailableData(funcData);

            // console.log("this.totalNumberOfData is ", this.totalNumberOfData);

            const serverMsg = await this.getDataFromServer({ ...funcData, type: "retrieve" });
            this.teamMembersArray = serverMsg.msg;
            
            this.totalNumberOfData = this.teamMembersArray.length;

            this.displayTeamMembers();

      };

      async display() {
            await this.getHeadingText();

            this.getTeamMembers();
            $(`.${this.sectionHeadingClass}`).html(this.heading);

            if(this.nextSectionClass) this.nextSectionClass.display();
      };

      render() {

            this.events();

            const mapViewText = this.setTxt({
                  attributes: this.mapViewBtnAttributes,
                  txt: "txt1474",
                  type: "title"
            });

            // let searchAndFilterBtn = this.getSearchAndFilterBtn();


            return `
                  <section ${this.getAttributes(this.mainAttributes, false)}>

                  <h2 ${this.getAttributes(this.sectionHeadingAttributes, false)} >  </h2>

                  <div ${this.getAttributes(this.teamMembersItemsAttributes, false)} >
                  
                  </div>
                  
                  </section>
            `;

      };

      // checkWindowSize() {

      //   console.log("Checking for desktop *******");

      //   var desktopWidth = 1000;
      //   if (window.innerWidth < desktopWidth) return false;

      //   $("." + this.mapClass).attr("data-smetio-is-visible", true);
      //   $("." + this.teamMembersClass).attr("data-smetio-is-visible", true);

      //   console.log("Desktop found *******");

      // };

      events() {

            // $("body").on("mousedown", "." + this.mapViewBtnClass, () => {

            //   $("." + this.mapClass).attr("data-smetio-is-visible", true);
            //   $("." + this.teamMembersClass).attr("data-smetio-is-visible", false);

            // });

            // $("body").on("mousedown", "." + this.listViewBtnClass, () => {

            //   $("." + this.mapClass).attr("data-smetio-is-visible", false);
            //   $("." + this.teamMembersClass).attr("data-smetio-is-visible", true);

            // });

            // window.addEventListener('resize', this.checkWindowSize);


      };

};
